import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import withContentful from './withContentful';

var Query =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Query, _Component);

  function Query(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    var data = _this.checkCache(props);

    _this.state = {
      fetched: data ? true : false,
      loading: false,
      error: null,
      data: data
    };

    if (data) {
      props.onLoad(_this.state);
    }

    return _this;
  }

  var _proto = Query.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.state.data) {
      this.requestContentfulData();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
      this.setState({
        fetched: false
      }, function () {
        _this2.requestContentfulData();
      });
    }
  };

  _proto.validateRequestRequirements =
  /*#__PURE__*/
  function () {
    var _validateRequestRequirements = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var _this3$props = _this3.props,
                    id = _this3$props.id,
                    contentType = _this3$props.contentType,
                    contentful = _this3$props.contentful,
                    include = _this3$props.include,
                    locale = _this3$props.locale,
                    parser = _this3$props.parser,
                    query = _this3$props.query; // Check for contentful context

                warning(contentful, 'No contentful context passed to <Query />');

                if (!contentful) {
                  return reject('No contentful context passed to <Query />');
                }

                var client = contentful.client,
                    contextLocale = contentful.locale; // Check to make sure a client is available

                warning(client, 'ContentfulClient not available via context on <Query />');

                if (!client) {
                  return reject('ContentfulClient not available via context on <Query />');
                }

                var hasQuery = !!(id || contentType || query === {}); // Check to make sure queryable props have been set

                warning(hasQuery, 'Query props not set on <Query />');

                if (!hasQuery) {
                  return reject('Query props not set on <Query />');
                }

                return resolve(true);
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function validateRequestRequirements() {
      return _validateRequestRequirements.apply(this, arguments);
    }

    return validateRequestRequirements;
  }();

  _proto.checkCache = function checkCache(props) {
    var contentful = props.contentful,
        parser = props.parser;

    if (!contentful) {
      return null;
    }

    var cacheKey = this.generateCacheKey(props);

    if (!contentful.client) {
      return null;
    }

    var cache = contentful.client.checkCache(cacheKey);
    return cache ? parser(cache, props) : null;
  };

  _proto.generateCacheKey = function generateCacheKey(props) {
    var contentful = props.contentful,
        contentType = props.contentType,
        id = props.id,
        include = props.include,
        locale = props.locale,
        query = props.query;

    if (!contentful) {
      return null;
    }

    var contextLocale = contentful.locale;
    var requestLocale = locale || contextLocale;

    if (id) {
      return JSON.stringify({
        id: id,
        options: _objectSpread({
          locale: requestLocale,
          include: include
        }, query)
      });
    }

    return JSON.stringify(_objectSpread({
      content_type: contentType,
      locale: requestLocale,
      include: include
    }, query));
  };

  _proto.fetchData =
  /*#__PURE__*/
  function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this4 = this;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.props.skip) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", Promise.resolve(null));

            case 2:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var _this4$props = _this4.props,
                    contentful = _this4$props.contentful,
                    contentType = _this4$props.contentType,
                    id = _this4$props.id,
                    include = _this4$props.include,
                    locale = _this4$props.locale,
                    query = _this4$props.query;

                _this4.validateRequestRequirements().then(function () {
                  var client = contentful.client,
                      contextLocale = contentful.locale,
                      renderPromises = contentful.renderPromises;
                  var requestLocale = locale || contextLocale;
                  var request = id ? client.getEntry(id, _objectSpread({
                    locale: requestLocale,
                    include: include
                  }, query)) : client.getEntries(_objectSpread({
                    'content_type': contentType,
                    locale: requestLocale,
                    include: include
                  }, query));

                  if (renderPromises) {
                    renderPromises.registerSSRObservable(_this4, request);
                  }

                  return request;
                }).then(resolve)["catch"](reject);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }();

  _proto.requestContentfulData = function requestContentfulData() {
    var _this5 = this;

    var _this$props = this.props,
        parser = _this$props.parser,
        onRequest = _this$props.onRequest,
        onLoad = _this$props.onLoad,
        onError = _this$props.onError;
    this.validateRequestRequirements().then(function () {
      _this5.setState({
        error: null,
        loading: true
      },
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                onRequest(_this5.state);

                _this5.fetchData().then(function (response) {
                  _this5.setState({
                    data: parser(response, _this5.props),
                    fetched: true,
                    loading: false
                  }, function () {
                    onLoad(_this5.state);
                  });
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    })["catch"](function (error) {
      _this5.setState({
        error: error,
        fetched: true,
        loading: false
      }, function () {
        onError(_this5.state);
      });
    });
  };

  _proto.getQueryResult = function getQueryResult() {
    return this.state;
  };

  _proto.render = function render() {
    var _this6 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        contentful = _this$props2.contentful;

    var finish = function finish() {
      return children(_this6.getQueryResult());
    };

    if (contentful && contentful.renderPromises) {
      return contentful.renderPromises.addQueryPromise(this, finish);
    }

    return finish();
  };

  return Query;
}(Component);

Query.propTypes = {
  children: PropTypes.func,
  contentType: PropTypes.string,
  id: PropTypes.string,
  include: PropTypes.number,
  query: PropTypes.object,
  parser: PropTypes.func,
  skip: PropTypes.bool,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  onRequest: PropTypes.func
};
Query.defaultProps = {
  children: function children(_ref2) {
    var data = _ref2.data,
        error = _ref2.error,
        fetched = _ref2.fetched,
        loading = _ref2.loading;
    return null;
  },
  include: 10,
  query: {},
  skip: false,
  parser: function parser(data, props) {
    return data;
  },
  onError: function onError() {},
  onLoad: function onLoad() {},
  onRequest: function onRequest() {}
};
export default withContentful(Query);